import React, { useState } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { CreateOrderForm } from './CreateOrderForm';

interface OrderHeaderProps {
  statusOptions: string[];
  selectedSortStatus: string;
  selectedFilterStatus: string;
  setStatusOptions: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedSortStatus: React.Dispatch<React.SetStateAction<string>>;
  setSelectedFilterStatus: React.Dispatch<React.SetStateAction<string>>;
}

interface SelectProps {
  value: string;
  onChange: (event: React.ChangeEvent<{ value: unknown }>) => void;
  options: string[];
  label: string;
}

const
  OrderHeader: React.FC<OrderHeaderProps> = ({
                                                   statusOptions,
                                                   setStatusOptions,
                                                   selectedSortStatus,
                                                   setSelectedSortStatus,
                                                   selectedFilterStatus,
                                                   setSelectedFilterStatus
                                                 }) => {
  const [openModal, setOpenModal] = useState(false);

  const handleCreateOrder = () => {
    window.location.href = '/order-admin';
  };

  const handleCloseModal = () => {
    // Set the URL for the admin path
    window.location.href = '/order-admin';
  };

  const handleSubmit = (data) => {
    console.log('Order submitted:', data);
    setOpenModal(false);
    // Here you would typically call an API to create the order
  };
  return (
    <>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h3" component="h3" gutterBottom>
            Orders
          </Typography>
          <Typography variant="subtitle2">
            Variants of orders created by sellers
          </Typography>
        </Grid>
        <Grid item display={'flex'} flexDirection={'column'} sx={{
          gap: '3'
        }}>
          <Grid item display={'flex'} justifyContent={'right'}>
            <Button
              sx={{ mt: { xs: 2, md: 0 } }}
              onClick={handleCreateOrder}
              variant="contained"
              startIcon={<AddTwoToneIcon fontSize="small" />}
            >
              Create Order
            </Button>
          </Grid>
          <Grid
            item
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            sx={{
              width: { xs: '100%', sm: 'auto' }, // Full width on small screens, auto on larger
              minWidth: { sm: 400 }, // Minimum width of 400px on sm and up
              gap: 2, // Gap between child elements
              mt: { sm: 2 } // Margin top
            }}
          >

          </Grid>

        </Grid>
      </Grid>


    </>
  );
};

export default OrderHeader;
